import { render, staticRenderFns } from "./AdminTopbar.vue?vue&type=template&id=bd90a80c&scoped=true&"
import script from "./AdminTopbar.vue?vue&type=script&lang=js&"
export * from "./AdminTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd90a80c",
  null
  
)

export default component.exports